import type { Race } from '../types';

export { londonFuelling } from './fuelling';
export { londonShopping } from './shopping';
export { londonRaceWeek } from './raceWeek';

/** London 2026 is a past trip, so it sits outside the Plan catalog. */
export const londonRace: Race = {
  id: 'london-2026',
  name: 'TCS London Marathon',
  city: 'London',
  country: 'UK',
  date: '2026-04-26',
  dateConfirmed: true,
  startTime: '09:36',
  timezone: 'Europe/London',
  lat: 51.4769,
  lng: 0.0005,
  url: 'https://www.tcslondonmarathon.com',
  major: true,
};

export const LONDON_LABEL = 'London 2026';
export const LONDON_GUN = 'Sunday 26 April · 09:36 BST';
